<template>
  <layout-simple :title="isLoading ? 'Loading...' : thg?.numberplate">
    <v-container class="padded">
      <thg-vehicle-card v-if="!isLoading && thg" :myThg="thg" />
      <v-card class="mb-10" max-width="515" v-else>
        <v-skeleton-loader class="mx-auto" type="card-avatar, article, article, actions"></v-skeleton-loader>
      </v-card>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import ThgVehicleCard from "@/components/thg/ThgVehicleCard.vue";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { Component } from "vue-property-decorator";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { ThgModule } from "@/store/modules/thg.store";
import { ThgThgMeViewModelGen } from "@/services/thg/v1/data-contracts";

@Component({
  components: {
    ThgVehicleCard,
    LayoutSimple
  }
})
export default class ThgVehicleDetail extends PartnerFallbackMixin {
  isLoading = false;

  thg: ThgThgMeViewModelGen | undefined = undefined;

  async mounted() {
    this.isLoading = true;
    const thgId = this.$route.params.thgId;

    try {
      await this.trySetByRouteOrDefault();
      await ThgModule.getMyThgs();

      this.thg = ThgModule.myThgs.find((v) => v.id == thgId);

      if (!this.thg) {
        this.$toast.error(this.$t("views.Error.subtitle"));
      }
    } catch (error) {
      this.$log.error((error as any).message);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>
